import {AstView, EnrichedAstNode} from '../../types';
import {findNodeById, findParentOfNodeById} from '../../AstSearchers';

export const checkIfCanMoveChildrenUp = (view: AstView, node: EnrichedAstNode | null) => {
    if (!node) {
        return false;
    }

    const isRootNode = node.internalId === view.tree.internalId;
    const hasMoreThanOneChild = view.tree.children.length > 1;

    if (isRootNode && hasMoreThanOneChild) {
        return false;
    }

    return true;
};

export const retrieveGroupingContext = (view: AstView, node: EnrichedAstNode) => {
    const isRootNode = node.internalId === view.tree.internalId;
    const parent = isRootNode ? node : findParentOfNodeById(view.tree, node.internalId);

    if (!parent) {
        throw new Error('failed to find parent');
    }

    return {
        parent,
        children: node.children,
        childIndex: parent.children.findIndex((n) => n.internalId === node.internalId),
    };
};

export const moveChildrenUp = (node: EnrichedAstNode, view: AstView) => {
    const {parent, children, childIndex} = retrieveGroupingContext(view, node);

    const isRootNode = node.internalId === view.tree.internalId;
    if (isRootNode && view.tree.children.length === 1) {
        view.tree = view.tree.children[0];
        return {node, parent, children, childIndex};
    }

    parent.children.splice(childIndex, 0, ...children);
    node.children = [];

    return {node, parent, children};
};

export const removeNodeFromView = (view: AstView, nodeId: string) => {
    const node = findNodeById(view.tree, nodeId);
    if (!node) {
        return view;
    }
    const {parent} = moveChildrenUp(node, view);
    parent.children = parent.children.filter((n) => n.internalId !== node.internalId);
    return view;
};

export const removeNodeAndChildrenFromView = (view: AstView, nodeId: string) => {
    const node = findNodeById(view.tree, nodeId);
    if (!node) {
        return view;
    }
    const {parent} = retrieveGroupingContext(view, node);

    parent.children = parent.children.filter((n) => n.internalId !== node.internalId);
    return view;
};
